'use es6';

import { List, Map as ImmutableMap } from 'immutable';
import { getDataKeys } from '../highcharts/chartUtils';
import { fromMetricKey, toMetricKey } from 'reporting-data/v2/dataset/datasetMetrics';
const count = series => series.count();
const sum = series => series.reduce((result, v) => result + (v || 0), 0);
const average = series => sum(series) / count(series);
const min = series => series.min();
const max = series => series.max();
const distinct = series => series.toSet().count();
const valid = series => series.filter(v => v != null && v !== undefined).count();
const missing = series => series.filter(v => v == null || v === undefined).count();
const METRICS = {
  count,
  sum,
  average,
  min,
  max,
  distinct,
  valid,
  missing
};
export const TOTAL_FIELD = '__total';
function pivotTransform(data, {
  keys,
  field,
  value,
  groupby,
  op,
  showTotals
}) {
  if (groupby.length === 0) {
    const dataByPivotField = data.groupBy(row => row.get(field));
    return List.of(ImmutableMap(keys.map(key => {
      const fn = METRICS[op];
      if (!fn) {
        throw new Error(`No aggregation function found for operator: ${op}, expected one of [${Object.keys(METRICS)}]`);
      }
      const pivotData = dataByPivotField.get(key) || List();
      return [key, op === 'count' || !value ? pivotData.getIn([0, toMetricKey({
        property: op,
        type: value
      })]) : fn(pivotData.map(r => r.find((v, k) => fromMetricKey(k).property === fromMetricKey(value).property)))];
    })).withMutations(map => showTotals ? map.set(TOTAL_FIELD, sum(map.toList())) : map));
  }
  const [groupField, ...rest] = groupby;
  return data.groupBy(r => r.get(groupField)).map((group, key) => pivotTransform(group, {
    keys,
    field,
    value,
    groupby: rest,
    op,
    showTotals
  }).map(r => r.set(groupField, key))).toList().flatten(1);
}

// https://vega.github.io/vega-lite/docs/pivot.html
export default ((dataset, {
  keys,
  field,
  value,
  groupby = [],
  op = 'sum',
  showTotals
}) => {
  if (!field) {
    throw new Error('Missing pivot field in pivot transform');
  }
  keys = keys || getDataKeys(dataset, field).sort();
  return dataset.update('data', data => pivotTransform(data, {
    keys,
    field,
    value,
    groupby,
    op,
    showTotals
  }));
});